import { Logger } from '@feature-hub/core';
import { HistoryServiceV2 } from '@feature-hub/history-service';
import { ApiKeyProviderV1 } from '@volkswagen-onehub/api-key-provider';
import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { CmsServiceV14 } from '@volkswagen-onehub/cms-service';
import { DisclaimerManagerV1 } from '@volkswagen-onehub/disclaimer-manager';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { FeatureappServiceV1Impl } from '@volkswagen-onehub/featureapp-service';
import { LayerManagerV25 } from '@volkswagen-onehub/layer-manager';
import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
import { UserInteractionServiceV1 } from '@volkswagen-onehub/user-interaction-service';
import React, { useContext } from 'react';
import { FeatureAppConfig } from '..';
import { CalculatorResult } from '../hooks/calculator/useCalculator';
import { OfertasV2 } from '../services/ofertas-service/v2';

export interface IOfertasContext {
	readonly featureAppId: string;
	readonly featureServices: any;
	readonly serviceConfigProvider: ServiceConfigProviderV1;
	readonly layerManager: LayerManagerV25;
	readonly logger: Logger;
	readonly historyService: HistoryServiceV2;
	readonly breacrumbService: BreadcrumbServiceV1;
	readonly pageInfoService: PageInfoServiceV1;
	readonly disclaimerManager: DisclaimerManagerV1;
	readonly contentService: FaContentServiceV1;
	readonly ofertasService: OfertasV2;
	readonly featureAppService: FeatureappServiceV1Impl;
	readonly apiKeyProvider: ApiKeyProviderV1;
	readonly tracking: TrackingManagerV1;
	readonly calculatorResult: CalculatorResult;
	readonly featureAppConfig: FeatureAppConfig;
	readonly userInteractionService: UserInteractionServiceV1;
	readonly cmsService: CmsServiceV14;
}

const defaultContext: IOfertasContext = {
	featureAppId: '' as string,
	featureServices: null,
	serviceConfigProvider: {} as ServiceConfigProviderV1,
	layerManager: {} as LayerManagerV25,
	logger: {} as Logger,
	historyService: {} as HistoryServiceV2,
	breacrumbService: {} as BreadcrumbServiceV1,
	pageInfoService: {} as PageInfoServiceV1,
	disclaimerManager: {} as DisclaimerManagerV1,
	contentService: {} as FaContentServiceV1,
	ofertasService: {} as OfertasV2,
	featureAppService: {} as FeatureappServiceV1Impl,
	apiKeyProvider: {} as ApiKeyProviderV1,
	tracking: {} as TrackingManagerV1,
	calculatorResult: {} as CalculatorResult,
	featureAppConfig: {} as FeatureAppConfig,
	userInteractionService: {} as UserInteractionServiceV1,
	cmsService: {} as CmsServiceV14,
};

export const OfertasContext =
	React.createContext<IOfertasContext>(defaultContext);
OfertasContext.displayName = 'OfertasContext';

export function useFeatureServices(): any {
	const { featureServices } = useContext(OfertasContext);

	if (!featureServices) {
		throw new Error('No featureServices context value was provided');
	}

	return featureServices;
}
